export default {

    availableStartDates: (state) => { 
        return Object.values(state.availableStartDateResponses).flat() || []
    },

    availableEndDates: (state) => { 
        return Object.values(state.availableEndDateResponses).flat() || []
    },

    availableStartDatesSet: (state) => { 
        const set = new Set()
        const availableStartDates = Object.values(state.availableStartDateResponses).flat() || []
        
        availableStartDates.forEach((dateStr)=>{
            const date = new Date(dateStr)
            const monthStr = `${date.getMonth()+1}`.length === 1 ? `0${date.getMonth()+1}` : `${date.getMonth()+1}`
            const dayStr = `${date.getDate()}`.length === 1 ? `0${date.getDate()}` : `${date.getDate()}`
            const formattedDateStr = `${date.getFullYear()}-${monthStr}-${dayStr}`
            set.add(formattedDateStr)
        })
        return set
    },

    availableEndDatesSet: (state) => { 
        const set = new Set()
        const availableEndDates = Object.values(state.availableEndDateResponses).flat() || []

        availableEndDates.forEach((dateStr)=>{
            const date = new Date(dateStr)
            const monthStr = `${date.getMonth()+1}`.length === 1 ? `0${date.getMonth()+1}` : `${date.getMonth()+1}`
            const dayStr = `${date.getDate()}`.length === 1 ? `0${date.getDate()}` : `${date.getDate()}`
            const formattedDateStr = `${date.getFullYear()}-${monthStr}-${dayStr}`
            set.add(formattedDateStr)
        })
        return set
    },

}